import { useEffect } from 'react';

/** Registers the offline shell service worker (installable PWA, §5.8). Production builds only. */
export function ServiceWorker() {
  useEffect(() => {
    if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return;
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  }, []);
  return null;
}
